import type { PricingUnit } from '@hotel-voice/shared';

/**
 * Money formatting for the guest pages. Rupees, no decimals unless there are
 * paise — a menu of whole-rupee prices should not read "₹120.00" down the
 * column.
 */
export function formatCurrency(amount: number): string {
  if (!Number.isFinite(amount)) return '—';
  const hasPaise = Math.round(amount * 100) % 100 !== 0;
  return `₹${hasPaise ? amount.toFixed(2) : String(Math.round(amount))}`;
}

const UNIT_LABEL: Record<PricingUnit, string> = { item: 'item', kg: 'kg' };

/**
 * "Free", "₹50", or "₹120 / kg". What a service row shows next to its name;
 * the laundry page uses the unit, the housekeeping page never has one.
 */
export function formatServicePrice(
  service: { type: string; charge: number; pricingUnit?: PricingUnit },
): string {
  if (service.type !== 'paid' || service.charge <= 0) return 'Free';
  const unit = service.pricingUnit ? ` / ${UNIT_LABEL[service.pricingUnit]}` : '';
  return `${formatCurrency(service.charge)}${unit}`;
}

/** Two-decimal arithmetic for line totals, so 3 × 12.5 is 37.5 and not 37.499999. */
export function multiplyMoney(unit: number, quantity: number): number {
  return Math.round(unit * quantity * 100) / 100;
}

export function sumMoney(values: readonly number[]): number {
  return Math.round(values.reduce((sum, value) => sum + value, 0) * 100) / 100;
}
